import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

export function filterExtensionOption(
   types: ExtensionOption[],
   searchText: string | null | undefined
): ExtensionOption[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const upper = term.toUpperCase();
      return types.filter((item) => {
         return item?.number?.toString().includes(upper) || item?.name?.toUpperCase().includes(upper);
      });
   } else {
      return types || [];
   }
}
